export const TOKEN_EXPIRY_ERROR_CODE = 811;
export const INTERACTION_EXPIRED = 'INTERACTION_EXPIRED';
export const PASSWORD_EXPIRED_ERROR_CODE = 809;
export const RATE_LIMITED_ERROR_CODE = 'rate_limited';

// We have to use the MSG here as the code - 812 - is also used for "Bad credentials"
export const SAME_PASSWORD_ERROR_MSG = 'New password rejected: Password should be different from your current password'; // eslint-disable-line max-len
